import React, {
  useState,
  useContext,
  useEffect
} from 'react';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  HelpMeChooseCategories
} from 'src/Common/constants';

import {
  getRecommendedOffers
} from 'src/Services/Services';

import {
  CallIconNew,
  ActionIcon,
  WhiteQuestionMarkIcon
} from 'src/Components/Common';

import {
  isMobileView
} from 'src/Utility/utility';

import {
  tagOnHelpMeChooseCallMeBackButtonClick
} from 'src/Tagging/SalesTagging';

import SpeedDrawer from 'src/Components/SpeedDrawer/SpeedDrawer';

import './NewHelpMeChoosePlan.css';

const NewHelpMeChoosePlan = () => {

  const salesContext = useContext(SalesContext);

  const [helpmeChoosePlanVisible, setHelpmeChoosePlanVisible] = useState(false);
  const [defaultOptions, setDefaultOptions] = useState(HelpMeChooseCategories);
  const [recommendedOptions, setRecommendedOptions] = useState([]);

  useEffect(() => {

    getRecommendedOffers()
      .then((res) => {
        setRecommendedOptions(res);
      })
      .catch((error) => console.log(error));
  }, []);

  const getInternetUsageOptions = (response) => {

    const ret = {};

    for (const option of defaultOptions) {

      for (const item of response) {

        if (typeof option.enterpriseType === 'string'
          && typeof item.enterpriseType === 'string'
          && item.enterpriseType.toLowerCase().includes(option.enterpriseType.toLowerCase())
        ) {

          ret[option.title] = option;
        }
      }
    }

    return Object.entries(ret).map(([_, item]) => item);
  };

  const showCallMeBack = () => {
    tagOnHelpMeChooseCallMeBackButtonClick();
    salesContext.setShowCallMeBack(true);
  };

  return (
    <div className="new-help-me-choose-main-wrapper">

      <div className='new-help-me-choose-container'>
        <div>
          <WhiteQuestionMarkIcon />
        </div>

        <div className='new-help-me-choose-text-container'>
          <div className='not-sure'>
            Not sure which one to choose?
          </div>

          <div className='new-help-me-choose-description'>
            Let us help you find the perfect plan to set you up for success
          </div>

        </div>
      </div>

      <div className='new-help-me-choose-btn-container'>

        <div className="new-help-me-choose-call-me-back-btn-container">
          <button
            className="new-help-me-choose-call-me-back-btn"
            onClick={showCallMeBack} >
            {
              !isMobileView() &&
              <div className='help-me-choose-call-me-btn-icon'>
                <CallIconNew />
              </div>
            }
            Call me back
          </button>
        </div>

        <div className="new-help-me-choose-call-me-back-btn-container">
          <button
            className="new-help-me-choose-btn"
            onClick={() => {
              setHelpmeChoosePlanVisible(true);
              setDefaultOptions(getInternetUsageOptions(recommendedOptions));
            }} >
            {
              !isMobileView() &&
              <div className='new-help-me-choose-btn-icon'>
                <ActionIcon />
              </div>
            }
            Help me choose
          </button>
        </div>
      </div>

      <SpeedDrawer
        isOpen={helpmeChoosePlanVisible}
        onClose={() => setHelpmeChoosePlanVisible(false)}
      />

    </div>
  );
};

export default NewHelpMeChoosePlan;